import { FC, useCallback } from 'react';
import {
  ObjectType,
  Spinner,
  useObjectLockQuery,
  useRoleQuery,
  checkLockOnPage,
  RoleDto,
  useIsAdmin,
} from '@atlas-frontend/sdk';
import { path } from '../../paths';
import { useNavigateTo } from '../../paths/useNavigateTo';
import { useNumericParam } from '../../common/useEntityIdParam';
import { Forbidden } from '../Forbidden';
import { NotFound } from '../NotFound';
import { RoleForm } from './RoleForm';

export const RoleClone = () => {
  const roleId = useNumericParam('id');

  if (!useIsAdmin()) {
    return <Forbidden />;
  }

  if (!roleId) {
    return <NotFound />;
  }

  return <RoleCloneInner roleId={roleId} />;
};

const RoleCloneInner: FC<{ roleId: number }> = ({ roleId }) => {
  const { data: role, isLoading } = useRoleQuery({
    id: roleId,
  });
  const { data: lockData } = useObjectLockQuery({
    objectId: roleId,
    objectType: ObjectType.Role,
  });
  const navigateToRoleView = useNavigateTo(path.roleDetails, { id: roleId });

  checkLockOnPage(lockData, () => navigateToRoleView());

  const handleCancel = useCallback(() => {
    navigateToRoleView();
  }, [navigateToRoleView]);
  const handleSuccess = useCallback(
    (response: RoleDto) => {
      navigateToRoleView(
        { id: response.id },
        { state: { saved: 'success', noBlocker: true } }
      );
    },
    [navigateToRoleView]
  );

  if (isLoading) {
    return <Spinner />;
  }

  if (!role) {
    return null;
  }

  return (
    <RoleForm
      mode="clone"
      defaultValues={role}
      onClickCancel={handleCancel}
      onSuccess={handleSuccess}
    />
  );
};
